const cases = {
  'STRING': 'STRING',
  'STRING__MATCH': 'STRING',
  'STRING__NOT_MATCH': 'STRING',
  'NUMBER': 'NUMBER',
  'NUMBER__MATCH': 'NUMBER',
  'NUMBER__NOT_MATCH': 'NUMBER',
  'NUMBER__GREATER_THAN': 'NUMBER',
  'NUMBER__GREATER_THAN_OR_EQUAL': 'NUMBER',
  'NUMBER__LESS_THAN': 'NUMBER',
  'NUMBER__LESS_THAN_OR_EQUAL': 'NUMBER',
  'NUMBER__IN_RANGE': 'NUMBER_RANGE',
  'DATE': 'DATE',
  'DATE__MATCH': 'DATE',
  'DATE__NOT_MATCH': 'DATE',
  'DATE__GREATER_THAN': 'DATE',
  'DATE__GREATER_THAN_OR_EQUAL': 'DATE',
  'DATE__LESS_THAN': 'DATE',
  'DATE__LESS_THAN_OR_EQUAL': 'DATE',
  'DATE__IN_RANGE': 'DATE_RANGE',
  'ENUM': 'ENUM',
  'ENUM__IN': 'ENUM_IN',
  'ENUM__MATCH': 'ENUM',
  'ENUM__NOT_MATCH': 'ENUM',
  'RESOURCE': 'RESOURCE',
  'RESOURCE__MATCH': 'RESOURCE',
  'RESOURCE__NOT_MATCH': 'RESOURCE',
  'RESOURCE__IN': 'RESOURCE_IN',
}

const getCaseString = (fieldType, operator) => {
  // console.log(fieldType, operator)
  // console.log(cases[`${fieldType}${operator ? `__${operator}` : ''}`])
  return `${fieldType}${operator ? `__${operator}` : ''}`
}

export const getInputType = (fieldType, operator) => cases[getCaseString(fieldType, operator)] || 'STRING'



// WEBPACK FOOTER //
// ./src/utils/criteria.js